import { useState, useLayoutEffect } from "react";

export const useIsOverflowing = (ref) => {
  const [isOverflowing, setIsOverflowing] = useState(undefined);

  useLayoutEffect(() => {
    const checkOverflow = () => {
      if (!ref?.current) return;

      const el = ref.current;
      const status = el.scrollWidth > el.clientWidth;
      setIsOverflowing(status);
    };

    checkOverflow();

    window.addEventListener("resize", checkOverflow);

    return () => window.removeEventListener("resize", checkOverflow);
  }, [ref]);

  return isOverflowing;
};
